<div class="d-none d-lg-flex flex-row align-items-center h-100">
  <div class="border-left border-white social-item" *ngFor="let i of socials">
    <a class="text-white" [href]="i.url" target="_blank" title="{{i.title}}" appEmptyTitle>
      <img [src]="i.img_white.path"  height="15" alt="{{i.title}}">
    </a>
  </div>
</div>
